export default __webpack_public_path__ + "static/media/gw1.77cd573c.webp";